import React from 'react';

// DEPENDENCIES
import isFunction from 'lodash/isFunction';
import { useParams } from 'react-router';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions.js';

// CONTEXT
import { useLogContext } from '../../helpers/logContext';

// CORE COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// STYLES
import styles from './commentForm.module.scss';

// MAIN COMPONENT
const CommentForm = ({ name, formArgs, controlNames, endpoints }) => {

  // REACT ROUTER
  const { recordID } = useParams();

  // CONTEXT
  const { logs: { [name]: { fetch } = {} } } = useLogContext() || {};
  const { endpoint = endpoints?.add } = formArgs;

  // RENDER
  return (
    <Form
      className={styles.form}
      method="POST"
      endpoint={isFunction(endpoint) ? endpoint(recordID) : endpoint}
      initialValues={isFunction(formArgs?.params) ? formArgs.params(recordID) : formArgs?.params}
      onSuccess={() => {
        fetch();
        doCallback(formArgs?.onSuccess);
      }}
      loadingMessage="Adding comment"
      errorMessage="Unable to add comment."
      successMessage="Comment added."
      resetOnSuccess
    >
      <Form.Body>
        <Form.Textarea
          name={controlNames?.body} // This is needed for inconsistenet BE implementation
          placeholder="Type comment here"
          fullWidth
          required
        />
      </Form.Body>
      <div className={styles.footer}>
        {!!formArgs?.addAsTask &&
          <Form.YesNo
            type="checkbox"
            name="add_as_task"
            text="Add as Task"
            numeric={false}
            cols={{ xs: 12 }}
            formGroup={{ className: 'p-0' }}
          />
        }
        <Button.Submit
          className="ms-auto"
          variant="success"
          icon="checkmark"
          fullWidth={false}
        />
      </div>
    </Form>
 );
};

// EXPORT
export default CommentForm;
